module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-3-8963f33092b522d1fa998b2526b29e3c.svg";